module["exports"] = [
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fr/address/postcode.js
// module id = 1267
// module chunks = 0